import { trpc } from "@/app/router";
import { ProductModelEditModal } from "@/components/modals/product-model/edit-modal";
import { ProductModelAddModal } from "@/components/modals/product-model/add-modal";




import { useQueryClient } from "@tanstack/react-query";
import {
  Outlet,
  createFileRoute,
  useNavigate,
  useSearch,
} from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { Loader2 } from "lucide-react";
import { Suspense, useEffect, useState } from "react";
import { Dialog, DialogContent } from "shadcn-ui";
import { z } from "zod";
import { withRouteProtection } from "@/lib/router/route-protection";
import { SECTION_PROTECTION } from "@/lib/router/protection-presets";



// Initialize dayjs and TZ locale JP
dayjs.extend(utc);
dayjs.extend(timezone);

const searchSchema = z.object({
  productModelId: z.string().optional(),
  type: z.enum(["edit", "add"]).optional(),
  needRefresh: z.boolean().optional(),
});

export const Route = createFileRoute("/_app/inventory/product-model/_modal")({
  component: RouteComponent,
  validateSearch: zodValidator(searchSchema),
  // ...withRouteProtection(SECTION_PROTECTION.PROJECT_EDITOR),
});

function RouteComponent() {
  const search = useSearch({
    from: "/_app/inventory/product-model/_modal",
  });

  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const queryClient = useQueryClient();

  useEffect(() => {
    if (search.productModelId || search.type === "add") {
      setOpen(true);
    } else {
      if (!open && search.productModelId) {
        queryClient.invalidateQueries(
          {
            refetchType: "none",
            queryKey: trpc.inventory.productModel.getById.queryOptions({
              productModelId: search.productModelId,
            }).queryKey,
          },
        );
        navigate({
          viewTransition: true,
          to: "/inventory/product-model",
        });
      }
      setOpen(open);
    }
  }, [search]);

  return (
    <div>
      <Outlet />
      {search.type && (
        <Dialog
          open={open}
        // onOpenChange={(open) => {
        // 	if (!open && search.productId) {
        // 		queryClient.removeQueries(
        // 			trpc.inventory.product.getById.queryOptions({
        // 				productId: search.productId,
        // 			}),
        // 		);
        // 		navigate({
        // 			viewTransition: true,
        // 			to: "/inventory/product",
        // 		});
        // 	}
        // 	setOpen(open);
        // }}
        >
          {search.productModelId && search.type === "edit" && (
            <Suspense fallback={<Loader2 className="animate-spin" />}>

              <ProductModelEditModal />

              {/* {search.type === "view" && (
              <ProductDetailModal />
            )} */}

            </Suspense>
          )}
          {search.type === "add" && (
            <ProductModelAddModal />
          )}
        </Dialog>
      )}
    </div>
  );
}
